import React from 'react';
import {Tabs, TabsListProps} from '@mantine/core';

export const EtroTabsList: React.FC<TabsListProps> = ({children, ...props}) => {
  return <Tabs.List {...props}>{children}</Tabs.List>;
};
